module.exports = __webpack_public_path__ + "img/bf-logo-square.5ca30711.svg";